import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import ReadAxios from "../../components/axiosComponent/read";
import {order_allotment_status} from '../../utils/constant'

const EwayBillActions = (props) => {

    const extendEwayBill = () =>{
     props.agGridReact.props.handleExtendModal(props.data,true)
    }
    return(
        <>
        
        <Button
         onClick={extendEwayBill}
          basic
          disabled={props.data?.delivery?.order?.allotment_status?.allotment_code!==order_allotment_status.allocated}
          size="mini"
          type="button"
          icon
          style={{width:"40%"}}
        >
           <img src="assets/svg/extent.svg" width="100%" height="100%"/>
        </Button>
      </>
    )
}

export default EwayBillActions;
